export const notEmptyList = (errStr = 'Error') => (list = []) => list.length > 0 || errStr;
export const notEmptyObject = (errStr = 'Error') => (obj = {}) => Object.keys(obj || {}).length > 0 || errStr;
export const notNull = (errStr = 'Error') => (data = null) => !!data || errStr;
export const notNullOrEmpty = (errStr = 'Error') => (value) => {
  if (value === null || value === undefined || value === '') return errStr;
  if (Array.isArray(value)) return value.length > 0 || errStr;
  if (typeof value === 'object') return Object.keys(value || {}).length > 0 || errStr;
  return true;
};
export const notEmptyString = (errStr = 'Error') => (str = '') => !!str.trim() || errStr;
export const minMaxChars = (errStr = 'Error', minChar = 0, maxChar = Infinity) => (str = '') => (str.length >= minChar && str.length <= maxChar) || errStr;
export const minChars = (errStr = 'Error', minChar = 0) => (str = '') => (str.length >= minChar) || errStr;
export const maxChars = (errStr = 'Error', maxChar = Infinity) => (str = '') => (str.length <= maxChar) || errStr;
export const maxSize = (errStr = 'Error', size = Infinity) => (file) => !file || (file && file.size < size) || errStr;
export const imageFileType = (errStr = 'Error') => (file) => !file || (file && !file.name.includes('jfif')) || errStr;
export const videoFileType = (errStr = 'Error') => (file) => !file || (file && !file.name.includes('mov')) || errStr;
export const notValidURL = (errStr = 'Error') => (str) => {
  const pattern = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
  if (str !== null && str !== '') {
    if (!pattern.test(str)) {
      return errStr;
    }
  }
  return true;
};
export const numberPattern = /^[0-9]+\.?[0-9]*$/;
const negativeNumberPattern = /^-?[0-9]+\.?[0-9]*$/;
export const notValidNumber = (errStr = 'Error') => (str = '') => (typeof str === 'string' && !Number.isNaN(str) && !Number.isNaN(parseFloat(str)) && numberPattern.test(str)) || errStr;
export const notValidNumberOrEmpty = (errStr = 'Error') => (str = '') => (typeof str === 'string' && !Number.isNaN(str) && !Number.isNaN(parseFloat(str)) && numberPattern.test(str)) || str === null || str.length === 0 || errStr;
export const notValidNumberNegative = (errStr = 'Error') => (str = '') => (typeof str === 'string' && !Number.isNaN(str) && !Number.isNaN(parseFloat(str)) && negativeNumberPattern.test(str)) || errStr;
export const notValidPercentage = (errStr = 'Error', minVal = 0, maxVal = 100) => (str = '') => (typeof str === 'string' && !Number.isNaN(str) && !Number.isNaN(parseInt(str, 10)) && parseInt(str, 10) >= minVal && parseInt(str, 10) <= maxVal) || errStr;
export const notNumberInBetween = (errStr = 'Error', minVal = 0, maxVal = 100) => (str = '') => (typeof str === 'string' && !Number.isNaN(str) && !Number.isNaN(parseFloat(str)) && numberPattern.test(str) && parseFloat(str) >= minVal && parseFloat(str) <= maxVal) || errStr;
export const notValidEmail = (errStr = 'Error') => (str) => {
  const regexEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  if (str !== null && str !== '') {
    if (!regexEmail.test(str)) {
      return errStr;
    }
  }
  return true;
};
export const notNumberInBetweenNegative = (errStr = 'Error', minVal = -100, maxVal = 100) => (str = '') => (typeof str === 'string' && !Number.isNaN(str) && !Number.isNaN(parseFloat(str)) && negativeNumberPattern.test(str) && parseFloat(str) >= minVal && parseFloat(str) <= maxVal) || errStr;
